import { render, staticRenderFns } from "./teamRecord.vue?vue&type=template&id=b194a7ba&scoped=true"
import script from "./teamRecord.vue?vue&type=script&lang=js"
export * from "./teamRecord.vue?vue&type=script&lang=js"
import style0 from "./teamRecord.vue?vue&type=style&index=0&id=b194a7ba&prod&lang=less"
import style1 from "./teamRecord.vue?vue&type=style&index=1&id=b194a7ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b194a7ba",
  null
  
)

export default component.exports